import React, {useState, useContext, useEffect} from 'react';
import styled from 'styled-components';
import Seletor from '../Seletor';
import {get,sortBy} from 'lodash-es';
import {DataContext} from '../../Data';
import { Paper } from '@material-ui/core';


const MainGrid = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: auto;
`

const Paper_ = styled(Paper)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 12px;
  padding: 12px;
`


export default function EditUserPermissionsUI(props) {
  const { f } = props;
  const { data } = useContext(DataContext);
  const { empresas } = data;
  const [ optMod, setOptMod ] = useState([]);
  const [ optEmp, setOptEmp ] = useState([]);
  const [ permEmpresas, setPermEmpresas_ ] = useState({});
  const [ permModulos, setPermModulos_ ] = useState({});
  const setter = what => (
    (what === 'empresas') ? [ permEmpresas, setPermEmpresas_] : (
      (what === 'modulos') ? [ permModulos, setPermModulos_ ] : [ null, null ]
    )
  )
  const setPerm = (what,type) => value => {
    let [ x, setX ] = setter(what)
    if (!setX) return
    let x_ = get(x, type, [])
    if (x_.includes(value)) return
    setX({ ...x, [type]: [...x_, value] })
  }
  const unsetPerm = (what,type) => value => {
    let [ x, setX ] = setter(what)
    if (!setX) return
    let x_ = get(x, type, [])
    // if (x.includes(value)) return
    setX({ ...x, [type]: x_.filter(it => it !== value) })
  }

  useEffect(() => {
    setOptEmp([
      { value: "all", label: "TODAS", sublabel: "Todas as empresas", show: "Todas as empresas" },
      ...sortBy(empresas,'Apelido').map(e => {
        let label = e.Cidade ? ` - ${e.Cidade} ` : " "
        label = e.Apelido + label + `(${e.Codigo})`
        let show = `[${e.Codigo}] ${e.RazaoSocial}`
        return { value: e.Codigo, label, sublabel: e.RazaoSocial, show }
      })
    ])
  }, [empresas])
  useEffect(() => {
    setOptMod([
      { value: "all", label: "TODOS", sublabel: "Todos os módulos", show: "Todos os módulos" },
      { value: "metricas", label: "Métricas", show: "Métricas"  },
    ])
  }, [])

  return (
    <MainGrid>
      <div>Empresas:</div>
      <Paper_>
        <MostraSituacao 
          placeholder="Adicionar empresa..."
          title="EMPRESAS LIBERADAS"
          color="rgba(42,191,132,1)"
          list={get(permEmpresas, 'allow', [])}
          addToList={setPerm('empresas', 'allow')}
          removeFromList={unsetPerm('empresas', 'allow')}
          full={optEmp} 
        />
        <MostraSituacao 
          placeholder="Adicionar empresa..."
          title="EMPRESAS RESTRITAS"
          color="rgba(191,117,110,1)"
          list={get(permEmpresas, 'block', [])}
          addToList={setPerm('empresas', 'block')}
          removeFromList={unsetPerm('empresas', 'block')}
          full={optEmp} 
        />
      </Paper_>
      <div>Módulos:</div>
      <Paper_>
        <MostraSituacao 
          placeholder="Adicionar módulo..."
          title="MÓDULOS LIBERADOS"
          color="rgba(42,191,132,1)"
          list={get(permModulos, 'allow', [])}
          addToList={setPerm('modulos', 'allow')}
          removeFromList={unsetPerm('modulos', 'allow')}
          full={optMod} 
        />
        <MostraSituacao 
          placeholder="Adicionar módulo..."
          title="MÓDULOS RESTRITOS"
          color="rgba(191,117,110,1)"
          list={get(permModulos, 'block', [])}
          addToList={setPerm('modulos', 'block')}
          removeFromList={unsetPerm('modulos', 'block')}
          full={optMod} 
        />
      </Paper_>
    </MainGrid>
  )
}

const SituacaoGrid = styled(Paper)`
  & {
    width: 100%;
  }
  /* height: 500px; */
  & > :first-child {
    background: ${props => props.color};
    /* background: linear-gradient(${props => props.color}, transparent); */
    grid-area: titulo;
    display: flex;
    justify-content: center;
    padding: 10px;
    color: #fff;
    text-shadow: 0px 0px 2px black;
    font-weight: bold;
  }
  & > :nth-child(3) {
    padding: 0px 30px;
    /* padding: 10px 30px; */
    /* flex: 1; */
  }
  & > :nth-child(2) {
    /* padding: 0px 20px 15px 20px; */
    padding: 0px 20px;
  }
`

function MostraSituacao (props) {
  const { list, addToList, removeFromList, full, title, color, placeholder } = props;
  let opts = full;
  const [ emp, setEmp ] = useState(null);
  const sett = (e,ref) => {
    let value = get(e, "value")
    if (!value) {
      setEmp(null)
      return
    }
    setEmp(e)
    addToList(e.value)
    let { clearSelection=()=>null } = ref;
    clearSelection();
  }
  const toShow = list.map(Id => full.find(el => el.value === Id))
  return (
    <SituacaoGrid color={color} >
    
      <div>{title}</div>
      <div>
      {toShow.map((item,i) => { 
        return (
          <Fll color={color}>
            <div>
              {item.show}
            </div>
            <div onClick={() => removeFromList(item.value)}>&times;</div>
          </Fll>
        )
      })}
      </div>

      <div>
      <Seletor
        fullWidth
        onChange={sett}
        value={emp}
        placeholder={placeholder}
        suggestions={opts}
      />
      </div>

    </SituacaoGrid>
  )
}

const Fll = styled.div`
  display: flex;
  padding: 5px 5px 5px 0px;
  & > :first-child {
    margin: 2px 0px;
    padding-left: 5px;
    border-left: 5px solid ${props => props.color};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 1 auto;
  }
  & > :nth-child(2) {
    display: none;
    margin: 0px 10px 0px 0px;
    font-size: 20px;
    width: 20px;
    height: 20px;
    justify-content: center;
    align-items: center;
    justify-self: center;
    align-self: center;
    cursor: pointer;
  }
  &:hover {
    background: #eee;
  }
  &:hover > :nth-child(2) {
    display: flex;
  }
  & > :nth-child(2):hover {
    box-shadow:
      0px 1px 3px 0px rgba(0,0,0,0.2),
      0px 1px 1px 0px rgba(0,0,0,0.14),
      0px 2px 1px -1px rgba(0,0,0,0.12);
  }
`
